import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import SwapIcon from '../../../../../../themes/svg/swapIcon';

const SwapItem = ({ itemId, swapProduct }) => {
  const swapThisItem = useCallback(() => {
    swapProduct(itemId);
  }, [itemId]);

  return (
    <div className="actionBarItem" onClick={swapThisItem} role="button" tabIndex="-1">
      <div className="actionBarIcon">
        <SwapIcon />
      </div>
      <span className="label link">Swap Blinds</span>
    </div>
  );
};

SwapItem.propTypes = {
  itemId: PropTypes.string.isRequired,
  swapProduct: PropTypes.func.isRequired,
};

export default SwapItem;
